import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EditorTextComponent } from './editor-text.component';

const routes: Routes = [{ path: '', component: EditorTextComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EditorTextRoutingModule { }
